import { CreateButton } from 'components/button/CreateButton';
import { DebouncedSearchInput } from 'components/data/DebouncedSearchInput';
import { DocumentTitle } from 'components/DocumentTitle';
import { TablePageLayout } from 'components/page/styled';
import { usePagedIndustriesDataSource } from 'custom_hooks/data_hooks/data_source/industriesDataSource';
import { CreateIndustriesModal } from 'pages/Settings/Industries/CreateIndustriesModal';
import { IndustriesTable } from 'pages/Settings/Industries/IndustriesTable';
import { SearchCreateButtonContainer } from 'pages/Settings/shared/styled';
import { useEffect, useState } from 'react';

export function IndustriesPage() {
    const dataSource = usePagedIndustriesDataSource({
        name: 'industries-table',
        defaultFilter: {
            nameSearch: '',
        },
    });
    const { setFilter, reloadPage } = dataSource;
    const [nameSearch, setNameSearch] = useState('');
    const [createModalOpen, setCreateModalOpen] = useState(false);

    const onIndustriesCreate = () => {
        setCreateModalOpen(false);
        reloadPage();
    };

    useEffect(() => {
        setFilter((currentFilter) => ({
            ...currentFilter,
            nameSearch,
        }));
    }, [nameSearch, setFilter]);

    return (
        <TablePageLayout>
            <DocumentTitle title="Industries Settings" />
            <SearchCreateButtonContainer>
                <DebouncedSearchInput
                    placeholder="Search"
                    value={nameSearch}
                    onChange={setNameSearch}
                />
                <CreateButton onClick={() => setCreateModalOpen(true)} />
                {createModalOpen && (
                    <CreateIndustriesModal
                        onCreate={onIndustriesCreate}
                        onClose={() => setCreateModalOpen(false)}
                    />
                )}
            </SearchCreateButtonContainer>
            <IndustriesTable dataSource={dataSource} />
        </TablePageLayout>
    );
}
